import React from 'react';
import { motion } from 'framer-motion';

export default function PrivacyScreen(): React.JSX.Element {
  return (
    <div className="min-h-screen bg-white">
      <section className="pt-32 pb-16 px-4 bg-slate-50">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider bg-amber-50 text-amber-500 mb-6">
              Legal
            </span>
            <h1 className="text-4xl font-extrabold text-slate-900 mb-4">Privacy Policy</h1>
            <p className="text-slate-500">Last updated: May 2026</p>
          </motion.div>
        </div>
      </section>

      <section className="py-12 px-4 bg-white">
        <div className="max-w-3xl mx-auto">
          {[
            {
              title: '1. Information We Collect',
              content: 'We collect information you provide directly, including name, email, phone number, professional details, and payment information. We also collect usage data and device information to improve our services.'
            },
            {
              title: '2. How We Use Your Information',
              content: 'Your information is used to provide course access, process payments, send notifications, improve our platform, and comply with legal obligations. We do not sell your personal data to third parties.'
            },
            {
              title: '3. Data Security',
              content: 'We implement industry-standard security measures including encryption, secure servers, and regular security audits. Payment information is processed securely through Razorpay and never stored on our servers.'
            },
            {
              title: '4. Cookies & Tracking',
              content: 'We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie preferences through your browser settings.'
            },
            {
              title: '5. Third-Party Services',
              content: 'We integrate with Google (authentication), Razorpay (payments), and WhatsApp (communications). These services have their own privacy policies and data handling practices.'
            },
            {
              title: '6. Your Rights',
              content: 'You have the right to access, correct, or delete your personal data. You may also object to processing or request data portability. Contact us to exercise these rights.'
            },
            {
              title: '7. Data Retention',
              content: 'We retain your data as long as necessary to provide services and comply with legal obligations. Upon account deletion, personal data is removed within 30 days, except where retention is required by law.'
            },
            {
              title: '8. Children\'s Privacy',
              content: 'Our services are not intended for individuals under 18 years of age. We do not knowingly collect data from children.'
            },
            {
              title: '9. Changes to This Policy',
              content: 'We may update this privacy policy periodically. We will notify you of significant changes via email or platform notifications.'
            },
            {
              title: '10. Contact Us',
              content: 'For privacy-related questions or concerns, please contact us at privacy@ecoleminds.com or through our Contact page.'
            },
          ].map((section, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.05 }}
              className="mb-8"
            >
              <h2 className="text-xl font-bold text-slate-900 mb-3">{section.title}</h2>
              <p className="text-slate-600 leading-relaxed">{section.content}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
